/**
 * Приведение даты с бэка к виду - DD.MM.YYYY, HH:MM:SS
 */
export function datetimeToString(datetimeString: string): string {
	return new Date(datetimeString).toLocaleString();
}

/**
 * Приведение даты с бэка к виду - DD.MM.YYYY HH:mm:ss
 */

export const convertDateFormString = (date: Date | string): string | null => {
	if (!date) {
		return null;
	}

	const parsedDate = new Date(date);
	if (Number.isNaN(parsedDate.getTime())) {
		return null;
	}

	return new Intl.DateTimeFormat('ru-RU', {
		year: 'numeric',
		month: '2-digit',
		day: '2-digit',
		hour: '2-digit',
		minute: '2-digit',
		second: '2-digit',
	}).format(parsedDate);
};

/**
 * Приведение даты с бэка к виду - DD.MM.YYYY
 */

export const convertOnlyDateFormString = (date: Date | string): string | null => {
	if (!date) {
		return null;
	}

	const parsedDate = new Date(date);
	if (Number.isNaN(parsedDate.getTime())) {
		return null;
	}

	return new Intl.DateTimeFormat('ru-RU', {
		year: 'numeric',
		month: '2-digit',
		day: '2-digit',
	}).format(parsedDate);
};

/**
 * Приведение секунд к виду - HH:mm:ss
 */

export const convertSecondsToFormat = (seconds: number) => new Date(seconds * 1000).toISOString().slice(11, 19);

/**
 * Приведение секунд к минутам с округлением
 */
export const convertSecondsToMin = (seconds: number) => Math.round(seconds / 60);

/**
 * конвертирует время для показа
 */
export const timeConverter = (s: number, hoursIsDisplay: boolean) => {
	const pad = (n: number) => `00${n}`.slice(-2);
	const ms = s % 1000;
	s = (s - ms) / 1000;
	const secs = s % 60;
	s = (s - secs) / 60;
	const mins = s % 60;
	const hrs = (s - mins) / 60;
	if (hoursIsDisplay) {
		return `${pad(hrs)}:${pad(mins)}:${pad(secs)}`;
	}
	return `${pad(mins)}:${pad(secs)}`;
};
